import { mainBus } from "@/common/buses";
import { useAppStore } from "@/common/store/appStore";
import { useEffect } from "react";

interface IUseOutsideClick {
  ref: React.RefObject<HTMLElement | null>;
}

export const useOutsideClick = ({ ref }: IUseOutsideClick) => {
  const isSearchBarOpen = useAppStore((state) => state.isSearchBarOpen);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        if (isSearchBarOpen) {
          mainBus.emit("close_search");
        }
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isSearchBarOpen]);
};
